import { AuthStrategy } from "../types";
import { Auth0Strategy } from "./Auth0Strategy";

export type AuthStrategyType = "auth0" | "entra";

export function createAuthStrategy(type: AuthStrategyType = "auth0"): AuthStrategy {
  switch (type) {
    case "auth0":
      return new Auth0Strategy();
    case "entra":
      throw new Error("Entra SSO strategy is not yet implemented.");
    default:
      throw new Error(`Unknown auth strategy: ${type}`);
  }
}
